export default __webpack_public_path__ + "static/media/andes_a_la_costa_19.25f78e56.JPG";